/*================================================================
‘Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
     File Description : Footer bar for objective Add | Edit Page
 --------------------------------------------------------------------------------- 
    Creation Details 
    Date Created				: 21/Aug/2020 
    Author						: Aditya Tijare
================================================================ 
*/
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataPublishingAction from "../../../../dataPublishing/news/actionButton";
import { accessRightActionCheck } from "../../../../../../utilities";
import { publishObjective } from "../../../../../../middleware/services/businessObjectiveApi";
import { actionSuccess, actionError } from "../../../../../../middleware/actions/utilityAction";
import { showAlertBox } from "../../../../../../middleware/actions/alertBoxAction";
import { useDispatch } from "react-redux";
import { COMMON_ACCESS_ACTION } from "../../../../../../constants";

const FooterBar = (props) => {
  const dispatch = useDispatch();

  const objectiveId = props.objectiveId || "";
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = Object.values(props?.hashArr)[props?.selectedIndex];
    let actionAccess = accessRightActionCheck(props?.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, [props?.selectedIndex]);

  let interfaceAccessSave = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SAVE);
  let interfaceAccessPublish = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.PUBLISH);

  return (
    <div className="form-submit-box">
          <div className="footer-layout">
            {props.selectedIndex > 0 || props.selectedIndex === undefined ? (         
                  <button
                    type="button"
                    className="btn btn-outline-dark cy-btn"
                    onClick={() => {
                      (props.selectedIndex === undefined && props.setCurrentTab(3)) ||
                        (props.selectedIndex < 3 && props.setCurrentTab(props.selectedIndex - 1));
                    }}
                  >
                    Previous
                  </button>             
            ) : null}

            {objectiveId !== "" && props.selectedIndex > -1 && props.selectedIndex < 2 ? (       
                  <button
                    type="button"
                    className="btn btn-outline-dark cy-btn"
                    onClick={() => {
                      props.selectedIndex < 2 && props.setCurrentTab(props.selectedIndex + 1);
                    }}
                  >
                    Next
                  </button>
            ) : null}
          </div>
          <div className="footer-layout">
            <Link to="/business-objective/customer">
              <button type="button" className="btn btn-outline-dark cy-btn">
                Cancel
              </button>
            </Link>
            {interfaceAccessPublish ? <DataPublishingAction objectiveId={props.objectiveId} {...props} /> : null}
            {interfaceAccessSave && props.activeStepper === "#basic" ? (
              <button
                type="button"
                className="btn btn-primary cy-btn"
                id="dev-objective-save"
                onClick={() => {
                  props.handleSave(true);
                }}
              >
                Save
              </button>
            ) : null}
            {interfaceAccessSave && props.activeStepper === "#content" ? (
              <button
                type="button"
                className="btn btn-primary cy-btn"
                id="dev-objective-save"
                onClick={() => {
                  props.handleSaveContent(true);
                }}
              >
                Save
              </button>
            ) : null}
            {interfaceAccessPublish && props.objectiveId && props.activeStepper === "#basic" ? (
              <button
                type="button"
                className="btn btn-primary cy-btn"
                id="dev-objective-save"
                onClick={() => {
                  dispatch(
                    showAlertBox({
                      okCallback: async () => {
                        await publishObjective(props.objectiveId)
                          .then((res) => {
                            if (res) {
                              dispatch(actionSuccess("Business Objective Published Successfully"));
                            } else {
                              dispatch(actionError("Something went wrong"));
                            }
                          })
                          .catch((err) => {
                            dispatch(actionError(err?.data?.message || "Something went wrong"));
                          });
                      },
                      content: " Are you sure you want to publish?",
                      okText: "Publish",
                      cancelText: "Cancel",
                      title: "dialogAlertCss",
                    })
                  );
                }}
              >
                Publish
              </button>
            ) : null}
          </div>
        </div>
  );
};

export default FooterBar;
